import React, {useState, useEffect, useRef } from 'react';
import { ref, onValue, update, remove } from 'firebase/database';
import { db, auth } from '../../../../FirebaseConfig';
import './QueueList.css';
import Toast from '../../../common/Toast';
import { getUsersOrganizations } from '../../../../api/organization';
import { useNavigate } from "react-router-dom";
import { FaInbox } from 'react-icons/fa';
import { MdOutlineGroupAdd } from "react-icons/md";
import classes from '../OrgnizationsList/organizationsList.module.scss';
import { StandardButton } from '../../../common/Button';
import { Table, Spinner } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { FaEdit } from "react-icons/fa";
import { BiSave } from "react-icons/bi";
import { MdDelete, MdOutlineCancel } from "react-icons/md";
import { IoQrCodeOutline } from "react-icons/io5";
import ModalConfirm from '../../../common/ModalConfirm/ModalConfirm';
import QueueInfoDetails from '../../../common/QueueInfo/QueueInfoDetails';
import { QrGenerator } from '../../../common/QrCode';



const QueueList = () => {
  const [queues, setQueues] = useState([]);
  const [editQueueId, setEditQueueId] = useState(null);
  const [editedQueue, setEditedQueue] = useState({});
  const [error, setError] = useState(null);
  const [userId, setUserId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [itemsPerPage] = useState(10); // Number of items to display per page
  const navigate = useNavigate();
  const [openMenuId, setOpenMenuId] = useState(null); 
  const [openDetailsId, setOpenDetailsId] = useState(null);// State to track open menu on mobile view
  const [loading, setLoading] = useState(true);  // Loading state to track the fetching
  const [loadingOrganizations, setLoadingOrganizations] = useState(true);
  const [loadingQueues, setLoadingQueues] = useState(true);
  const [queueId, setQueueId] = useState(null)
  // State for holding organizations and selected organization
  const [organizations, setOrganizations] = useState([]);
  const [selectedOrganization, setSelectedOrganization] = useState('');
  const toggleMenu = (queueId) => {
    setOpenMenuId(openMenuId === queueId ? null : queueId);
  };

  const [showQrCodeModal, setShowQrCodeModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  
    const generateQrCOde = () => {
      setShowQrCodeModal(true);
    };
  const [qrCodeQueueId, setQrCodeQueueId] = useState(null); // Track which queue's QR is shown

  const handleShowQrCode = (queueId) => {
      setQrCodeQueueId(queueId);
    };
    
  const handleCloseQrCode = () => {
      setQrCodeQueueId(null); // Reset when modal is closed
    };

  const toggleDetails = (queueId) => {
    setOpenDetailsId(openDetailsId === queueId ? null : queueId);
  };
  useEffect(() => {
    // Listen to the authentication state
    const unsubscribeAuth = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid);
      } else {
        setUserId(null);
        setQueues([]); // Clear queues if not authenticated
      }
    });

    return () => unsubscribeAuth();
  }, []);

  useEffect(() => {
    // Only set loading to false when both organizations and queues are done loading
    setLoading(loadingOrganizations || loadingQueues);
  }, [loadingOrganizations, loadingQueues]);

  useEffect(() => {
    setLoadingOrganizations(true); // Start loading organizations
    const currentUser = auth.currentUser;
        if (currentUser) {
          getUsersOrganizations(currentUser.uid).then((userOrganizations) => {
            setOrganizations(userOrganizations);
            setLoadingOrganizations(false);
          }).catch(error => {
            console.error("Error fetching organizations:", error);
            setLoadingOrganizations(false);
          });
        } else {
          setLoadingOrganizations(false)
        }

    setLoadingQueues(true);
    if (userId) {
      const queuesRef = ref(db, 'queues/');
      const unsubscribe = onValue(
        queuesRef,
        (snapshot) => {
          if (snapshot.exists()) {
            const data = snapshot.val()
            const queueArray = Object.keys(data)
              .map((key) => ({
                id: key,
                ...data[key],
              }))
              .filter((queue) => queue.userId === userId)
              .sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn));
              
            setQueues(queueArray);
          } else {
            setError('No queues found');
          }
          setLoadingQueues(false); // Queues loaded
        },
        (errorObject) => {
          setError('Failed to fetch data: ' + errorObject.message);
          setLoadingQueues(false);
          setIsLoading(false);
        }
      );
      return () => unsubscribe();
    }else {
      setLoadingQueues(false);
      setIsLoading(false);
  }
  }, [userId]);

  // Calculate the current queues to display based on the current page
  const indexOfLastQueue = currentPage * itemsPerPage;
  const indexOfFirstQueue = indexOfLastQueue - itemsPerPage;
  const currentQueues = queues.slice(indexOfFirstQueue, indexOfLastQueue);
  const totalPages = Math.ceil(queues.length / itemsPerPage);


  const handleEditClick = (queue) => {
    const today = new Date().toISOString().split('T')[0]; 
    setEditQueueId(queue.id);
    setEditedQueue({
      ...queue,
      createdOn: today, 
    });

  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedQueue((prevState) => ({
      ...prevState,
      [name]: name === "limit" ? (value.trim() === "" || Number(value) === 0 ? "Unlimited" : Number(value)) : value,
    }));
  };

  const handleSaveClick = async () => {
    const queueRef = ref(db, `queues/${editQueueId}`);
    try {
      await update(queueRef, {
        ...editedQueue,
        organizationId: editedQueue.organizationId, 
      });
      setQueues(prevQueues => 
        prevQueues.map(queue => 
          queue.id === editQueueId ? { ...queue, ...editedQueue } : queue
        )
      );
      setEditQueueId(null);
    } catch (error) {
      setError('Failed to update queue: ' + error.message);
    }
  };

  const deleteQueueRef = useRef()

  const openModal = (queue) => {
    if (deleteQueueRef.current) {
      setQueueId(queue.id)
      deleteQueueRef.current.openModal({
        id: queue.id,
        text: `Are you sure you want to remove ${queue.name ? queue.name: "this queue"} ?`,
      });
    } else {
      console.error('deleteQueueRef.current is null');
    }
  };

  const handleDeleteClick = async (queueId) => {
    const queueRef = ref(db, `queues/${queueId}`);
    try {
      await remove(queueRef);
      // Update the queues state by filtering out the deleted queue
      setQueues((prevQueues) => {
        const updatedQueues = prevQueues.filter((queue) => queue.id !== queueId);
        
        // Calculate the new total pages based on the updated queue list
        const newTotalPages = Math.ceil(updatedQueues.length / itemsPerPage);
        
        // Check if the current page is now greater than the total pages
        if (currentPage > newTotalPages && currentPage > 1) {
          // If so, set the current page to the new total pages (or to 1 if there are no pages)
          setCurrentPage(newTotalPages > 0 ? newTotalPages : 1);
        }
        
        return updatedQueues;
      });
    } catch (error) {
      setError('Failed to delete queue: ' + error.message);
    }
  };
  
  const handleQueueClick = (qId) => {
    navigate(`/dashboard/queue/monitor/${qId}`);
  };

  // Pagination button handlers
  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  if (isLoading) {
    return (
      <div className="spinnerWrapper">
        <Spinner animation="border" className="customSpinner" />
          <span>Loading...</span>
      </div>
    );
  }
  const hostId = localStorage.getItem("hostId")
  if(!hostId){
    return(
      <Toast
      title="Temporary warning!"
      subTitle="Please sign up to work on this page."
    />
    )
  }

  return (
    <>
      <ModalConfirm 
        ref={deleteQueueRef}
        onConfirm={() => handleDeleteClick(queueId)}
        title={'Delete Queue'}>
      </ModalConfirm>
      {loading ? (
        <div className={classes.spinnerWrapper}>
        <Spinner animation="border" className={classes.customSpinner} />
        <p>Loading Queues...</p>
        </div>
      ): queues.length === 0 ? (
      <div className={classes.noOrganizations}>
        <FaInbox className={classes.emptyIcon} />
        <p>No Queues in the list</p>
        <button className="button" onClick={() => navigate("/dashboard/queue/create")}> 
        Create Queue
        </button>
      </div>
    ) : (
      <div>
        {!hostId ? (
          <Toast
            title="Temporary warning!"
            subTitle="Please sign up to work on this page."
          />
        ) : error ? (
          <p> {error}</p>
        ) : currentQueues.length > 0 ? (
          <>
            <h4>Queue List</h4>
            <div className="button-container">
              <div className="hide-on-mobile">
              <StandardButton className="button" onClick={() => navigate("/dashboard/queue/create")}>
                Create Queue
              </StandardButton>
              </div>  
            {/* Show icon on mobile */}
          <NavLink to="/dashboard/queue/create" className="show-on-mobile">
            <MdOutlineGroupAdd/>
            <span>Create Queue</span>
          </NavLink>
            </div>
            <Table className={classes.table}>
              <thead>
                <tr>
                <th className="hide-on-mobile" key="1">#</th>
                  <th className="hide-on-mobile" key="2">Queue Name</th>
                  <th className="hide-on-mobile" key="3">Description</th>
                  <th className="hide-on-mobile" key="4">Joining Id</th>
                  <th className="hide-on-mobile" key="5">Created On</th>
                  <th className="hide-on-mobile" key="6">Organization</th>
                  <th className="hide-on-mobile" key="7">Limit</th>
                  <th className="hide-on-mobile" key="8">Status</th>
                  <th className="hide-on-mobile" key="9"style={{ width: 0 }}>Actions</th>
                </tr>
              </thead>
              <tbody className={`mobile-table-row`}>
                {currentQueues.map((queue, index) => ( 
                  <>
                  <tr key={queue.id} className={(index + 1) % 2 === 0 ? classes.evenRow : classes.oddRow} >
                    {editQueueId === queue.id ? (
                      <>
                        <td className={`${classes.tData} hide-on-mobile`}>{indexOfFirstQueue + index + 1}</td>
                        <td className={`${classes.tData} hide-on-mobile`}><input type="text" name="name" value={editedQueue.name} onChange={handleInputChange} /></td>
                        <td className="hide-on-mobile">
                          <textarea
                            name="description"
                            value={editedQueue.description || ''}
                            onChange={handleInputChange}
                            rows="3"
                            cols="20"
                            placeholder="Enter description"
                          ></textarea>
                        </td>
                        <td className="hide-on-mobile">
                          <div>
                            <textarea
                              value={queue.id}
                            ></textarea>
                          </div>
                        </td>
                        <td className="hide-on-mobile">{queue.createdOn}</td>
                        <td className="hide-on-mobile">
                        <select
                            name="organization"
                            value={editedQueue.organizationId || ''} // Use organizationId to store the selected ID
                            onChange={(e) => {
                              let selectedOrg = '';
                              if (e.target.value) {selectedOrg = organizations.find((org) => org.id === e.target.value);}
                              
                              setEditedQueue((prevState) => ({
                                ...prevState,
                                organizationId: selectedOrg?selectedOrg.id: '', // Store the ID (for database reference)
                                organization: selectedOrg?selectedOrg.orgName: '', // Store the Name (for UI display)
                              }));
                            }}
                          >
                          <option value="">Select Organization</option>
                          {organizations.map((org) => (
                            <option key={org.id} value={org.id}>
                              {org.orgName}
                            </option>
                          ))}
                        </select>
                        </td>
                    <td className="hide-on-mobile"><input type="number" name="limit" min="0" value={editedQueue.limit} onChange={handleInputChange} /></td>
                    <td className="hide-on-mobile">
                      <select name="status" value={editedQueue.status || ''} onChange={handleInputChange}>
                        <option value="" disabled>Select Status</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                        <option value="Paused">Paused</option>
                      </select>
                    </td>
                    <td>
                      <p className={`${classes.buttonsBlock} hide-on-mobile`}>
                        <StandardButton onClick={handleSaveClick}>Save</StandardButton>
                        <StandardButton onClick={() => setEditQueueId(null)}>Cancel</StandardButton>
                      </p>
                    </td>
                    <td>
                    <div className="edit-only-mobile">
                        <td className={classes.tData} data-label="Queue Name"><input type="text" name="name" value={editedQueue.name} onChange={handleInputChange} /></td>
                        <td data-label="Description">
                          <textarea
                            name="description"
                            value={editedQueue.description || ''}
                            onChange={handleInputChange}
                            rows="3"
                            cols="20"
                            placeholder="Enter description"
                          ></textarea>
                        </td>
                        <td data-label="Organization">
                        <select
                            name="organization"
                            value={editedQueue.organizationId || ''}
                            onChange={(e) => {
                              let selectedOrg = '';
                              if (e.target.value) {selectedOrg = organizations.find((org) => org.id === e.target.value);}
                              
                              setEditedQueue((prevState) => ({
                                ...prevState,
                                organizationId: selectedOrg?selectedOrg.id: '', 
                                organization: selectedOrg?selectedOrg.orgName: '',
                              }));
                            }}
                          >
                          <option value="">Select Organization</option>
                          {organizations.map((org) => (
                            <option key={org.id} value={org.id}>
                              {org.orgName}
                            </option>
                          ))}
                        </select>
                        </td>
                    <td data-label="Limit"><input type="number" name="limit" min="0" value={editedQueue.limit} onChange={handleInputChange} /></td>
                    <td data-label="Status">
                      <select name="status" value={editedQueue.status || ''} onChange={handleInputChange}>
                        <option value="" disabled>Select Status</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                        <option value="Paused">Paused</option>
                      </select>
                    </td>
                    <td>
                    <div className="actions-container">
                    <div className="iconContainer">
                      <BiSave style={{ fontSize: 25 }}onClick={handleSaveClick} className="icon saveIcon" />
                      <MdOutlineCancel style={{ fontSize: 25 }}onClick={() => setEditQueueId(null)} className="icon cancelIcon" />
                    </div>
                    </div>
                    </td>
                    </div>
                    </td>
                  </>      
                ) : (
                  <>
                  <td className={`${classes.tData} hide-on-mobile`}>{indexOfFirstQueue + index + 1}</td>
                  <td className="hide-on-mobile">
                  <span 
                    style={{ cursor: "pointer", color: "#3a3768",fontWeight: "bold", textDecoration: " underline"}} 
                    onClick={() => handleQueueClick(queue.id)}>
                    {queue.name}
                  </span>
                </td>
                  <td className="hide-on-mobile">{queue.description}</td>
                  <td className="hide-on-mobile">
                    <IoQrCodeOutline className="qrIconLink" onClick={() => handleShowQrCode(queue.id)} />
                    <span style={{ marginLeft: "15px", cursor:"pointer" }} onClick={() => handleShowQrCode(queue.id)}>{queue.id}</span>
                  {qrCodeQueueId === queue.id && (
                    <QrGenerator queueId={queue.id} show={true} onClose={handleCloseQrCode} />
                  )}
                </td>
                  <td className="hide-on-mobile">{queue.createdOn}</td>
                  <td className="hide-on-mobile">{organizations.map(org => {if (org.id===queue.organizationId) return org.orgName})}</td>
                  <td className="hide-on-mobile">{queue.limit === 0 || queue.limit === "0" || queue.limit === "" ? "Unlimited" : queue.limit}</td> 
                  <td className="hide-on-mobile">{queue.status}</td>
                  <td className={classes.actionsRow}>
                <p className="hide-on-mobile">
                  <StandardButton onClick={() => handleEditClick(queue)}>Edit</StandardButton>
                  <StandardButton onClick={() => openModal(queue)}>Delete</StandardButton>
                    </p>
                  {/* Only for mobile view */}
                   <td className='cardContainer'>
                    <td data-label="Queue Name-">
                        <span 
                          style={{ cursor: "pointer", color: "#3a3768",fontWeight: "bold", textDecoration: " underline"}} 
                          onClick={() => handleQueueClick(queue.id)}
                        >
                          {queue.name}
                        </span>
                      </td>
                    <td data-label="Description-">{queue.description}</td>
                    <td data-label="Created On-">{queue.createdOn}</td>
                    <td data-label="Organization-">
                        {
                          (() => {
                            const org = organizations.find(org => org.id === queue.organizationId);
                            return !org || !org.orgName || org.orgName === "Select Organization" ? "N/A" : org.orgName;
                          })()
                        }
                      </td>
                    <td data-label="Limit-">{queue.limit === 0 || queue.limit === "0" || queue.limit === "" ? "Unlimited" : queue.limit}</td> 
                    <td>
                    <div className="status-button-container">
                      <span className={`status-button ${queue.status === 'Active' ? 'status-active' : queue.status === 'Inactive' ? 'status-inactive' : 'status-paused'}`}>
                        {queue.status}
                      </span>
                    </div>
                    </td>
                    <td className="icon-link">
                      <div className="icon-row">
                        <div className="icon-container">
                        <IoQrCodeOutline className="queue-id" onClick={() => handleShowQrCode(queue.id)} />
                            {qrCodeQueueId === queue.id && (
                              <QrGenerator queueId={queue.id} show={true} onClose={handleCloseQrCode} />
                            )}
                          <span className="queue-id" onClick={() => handleShowQrCode(queue.id)}>{queue.id}</span>
                        </div>
                        <div className="actions-container">
                          <div className="iconContainer">
                            <FaEdit onClick={() => handleEditClick(queue)} className="icon editIcon" />
                            <MdDelete onClick={() => openModal(queue)} className="icon deleteIcon" />
                          </div>
                        </div>
                      </div>
                    </td>
                       </td>
                       </td> 
                      </>
                    )}
                  </tr>
                  <tr>
                  </tr>
                  </>
                ))}
              </tbody>
            </Table>
            <div className="pagination-controls">
              <StandardButton onClick={prevPage} disabled={currentPage === 1}>Previous</StandardButton>
              <span>Page {currentPage} of {totalPages}</span>
              <StandardButton onClick={nextPage} disabled={currentPage === totalPages}>Next</StandardButton>
            </div>
          </>
        ) : null}
      </div>
    )}
  </>
  
  );
};

export default QueueList;